const MAGIC_NUMBER = 0.4899999999999999409231;

export function getApiKeySegmentFromSeed(seed: number): string {
  return 2 * Math.sin(seed) * Math.cos(seed) >
    Math.pow(Math.sin(-0.7 * seed), 2) +
      Math.pow(Math.cos(-Math.sqrt(MAGIC_NUMBER) * seed), 2)
    ? "AFr"
    : "GDo";
}
